<template>
  <div>
    <div class="iDalgo-Template-Item" @click="handleToTemplateEdit">
      <el-row class="align-center">
        <el-col :span="1">
          <!-- <el-checkbox v-model="checked"></el-checkbox> -->
        </el-col>
        <el-col :span="3">
          {{ template.createdAt | moment('DD/MM/Y') }}
        </el-col>
        <el-col class="col-type" :span="2">
          {{ template.totalList || 0 }}
        </el-col>
        <el-col :span="11">
          <span>{{ template.name }}</span>
        </el-col>
        <el-col :span="7" class="flex-end">
          <button @click.stop="showDuplicateDialog" class="button-icon">
            <svgicon name="duplicate"></svgicon>
            <span>{{ $t('actions.duplicate') }}</span>
          </button>
          <button @click.stop="showIntegrationLink" class="button-icon">
            <svgicon name="link"></svgicon>
            <span>{{ $t('actions.share') }}</span>
          </button>
          <button @click.stop="toTemplateEdit" class="button-icon">
            <svgicon name="pen"></svgicon>
            <span>{{ $t('actions.edit') }}</span>
          </button>
          <button @click.stop="handleDelete" class="button-icon">
            <svgicon name="bin"></svgicon>
            <span>{{ $t('actions.delete') }}</span>
          </button>
        </el-col>
      </el-row>
    </div>

    <el-dialog
      :title= "$t('iDalgoDialogs.duplicate.title')"
      :visible.sync="duplicateDialogVisible"
      width="30%"
      center
      class="duplicateDialog">
      <span>{{ $t('iDalgoDialogs.duplicate.description') }}</span>
      <div class="mrg-20"></div>
      <el-form :model="duplicateTemplate" :rules="rules" ref="duplicateTemplate" @submit.native.prevent>
        <el-form-item prop="name">
          <el-input v-model="duplicateTemplate.name" :placeholder="$t('iDalgoDialogs.duplicate.placeholderName')" @keyup.enter.native="handleDuplicate"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="duplicateDialogVisible = false">{{ $t('actions.cancelButton') }}</el-button>
        <el-button type="primary" @click="handleDuplicate">{{ $t('actions.duplicate') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('iDalgoDialogs.integrationLink.title')"
      :visible.sync="integrationLinkDialogVisible"
      width="50%"
      center
      class="integrationLinkDialog">
      <div class="mrg-20"></div>
      <pre>{{ integrationLink }}</pre>
      <span slot="footer" class="dialog-footer integrationLink-footer">
        <el-button
          type="primary"
          @click="copyToClipboardHandler"
          :border="false">{{ $t('actions.copy') }}</el-button>
        <el-button @click="integrationLinkDialogVisible = false">{{ $t('actions.cancelButton') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getCopyName } from '@/services/tools'
import { iframeBundle } from '@/services/generators'
import '@/components/icons'

export default {
  name: 'iDalgo-Template-Item',
  props: {
    template: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      checked: false,
      duplicateDialogVisible: false,
      duplicateTemplate: {},
      rules: {
        name: [
          { required: true, message: this.$t('iDalgoDialogs.duplicate.alertMessageHasName'), trigger: 'blur' },
          { min: 3, max: 255, message: this.$t('iDalgoDialogs.duplicate.alertMessage'), trigger: 'change' }
        ]
      },
      integrationLink: '',
      integrationLinkDialogVisible: false
    }
  },
  methods: {
    toTemplateEdit () {
      this.$router.push({ name: 'editTemplate', params: { id: this.template.id } })
    },
    handleToTemplateEdit ($e) {
      this.toTemplateEdit()
    },
    showDuplicateDialog () {
      let copy = this.$t('duplicateCopyName')
      this.duplicateTemplate = {
        name: getCopyName(this.template.name, copy),
        type: this.template.type,
        size: this.template.size,
        sections: this.template._sections
      }
      this.duplicateDialogVisible = true
    },
    showIntegrationLink () {
      this.integrationLink = iframeBundle(this.template.id)
      this.integrationLinkDialogVisible = true
    },
    handleDelete () {
      this.$confirm(this.$t('iDalgoDialogs.deleteTemplate.message'), this.$t('iDalgoDialogs.deleteTemplate.title'), {
        confirmButtonText: this.$t('actions.delete'),
        cancelButtonText: this.$t('actions.cancelButton'),
        type: 'warning'
      }).then(() => {
        this.$store.dispatch('templates/deleteTemplate', this.template.id).then(() => {
          this.$notify({
            message: this.$t('iDalgoDialogs.deleteTemplate.notification')
          })
        })
      }).catch(() => {})
    },
    handleDuplicate () {
      this.$refs['duplicateTemplate'].validate(valid => {
        if (valid) {
          this.$store.dispatch('templates/duplicateTemplate', this.duplicateTemplate)
          this.duplicateDialogVisible = false
        } else {
          return false
        }
      })
    },
    copyToClipboardHandler () {
      this.$clipboard(this.integrationLink)
      this.$message({
        type: 'success',
        message: this.$t('iDalgoDialogs.notifications.copy')
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.iDalgo-Template-Item {
  box-sizing: border-box;
  display: flex;
  width: 100%;
  height: 60px;
  margin-bottom: 10px;
  box-shadow: inset 4px 0 0 0 $color1;
  color: $color1;
  font-family: 'robotolight';
  font-size: 14px;
  background: $white;
  cursor: pointer;
}

.iDalgo-Template-Item >>> .el-row {
  width: 100%;
  display: flex;
}

.iDalgo-Template-Item .el-row >>> .el-col {
  overflow-wrap: break-word;
}

.button-icon {
  border: none;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s;

  span {
    transition: all 0.2s;
  }

  .svg-icon {
    transition: all 0.2s;
  }

  &:hover {
    span {
      color: $color1;
    }
    .svg-icon {
      fill: $color1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/iDalgo-Template-Item.vue